import React from 'react';
import {useHeader} from '../../../../_metronic/layout';
import {useIntl} from 'react-intl';
import SubheaderBar from '../../_common/components/SubheaderBar';
import UsersActionsFilters from '../components/UsersActionsFilters';
import UsersActionsTable from '../components/UsersActionsTable';
import {UsersActionsUIProvider} from '../components/UsersActionsUIContext';

const UsersActions = () => {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: 'users-actions-page-header',
    defaultMessage: 'Users actions page'
  }));

  return (
    <UsersActionsUIProvider>
      <SubheaderBar>
        <UsersActionsFilters/>
      </SubheaderBar>
      <UsersActionsTable/>
    </UsersActionsUIProvider>
  );
};

export default UsersActions;
